import React, { useState, useEffect } from "react";
import axios from "axios";
import {useParams} from "react-router-dom";

const EditMachine = () => {
  const [formData, setFormData] = useState({
    organisatie: '',
    influx_Serienummer: '',
    machine_Serienummer: '',

    cleanorg: '',

    machine_Model: '',
    machine_Merk: '',
    machine_Naam: '',

    hulpstuk: '',
    hulpstuknummer: '',
    hulpstukkleur: '',
    hulpstukken: [],

    hulpstuk_machine: 'Selecteer Machine Voor Hulpstukken',
    dbc_machine: 'Kies Een Vergelijkbare Machine',

    macaddress: '',

    machines: [],
  });

  const [organizations, setOrganizations] = useState([]);
  const [image, setImage] = useState(null);
  const [manual, setManual] = useState(null);
  const [configUrl, setConfigUrl] = useState(null);

  const { serialNumber } = useParams();

  useEffect( () => {
    const loadMachine = async () => {
      const response = await axios.get(`/api/machine/get/${serialNumber}`)

      console.log(response)
      formData.organisatie = response.data.organization;
      formData.influx_Serienummer = response.data.loggerId;
      formData.machine_Serienummer = response.data.serialNumber;

      formData.cleanorg = response.data.cleanorg;

      formData.machine_Model = response.data.model;
      formData.machine_Merk = response.data.brand;
      formData.machine_Naam = response.data.alias;
      formData.old = response.data.serialNumber;

      formData.macaddress = response.data.macaddress;

      formData.elektrischOnderstel = response.data.elektrischOnderstel;

      formData.hulpstuk_machine = response.data.brand + " " + response.data.alias;
      formData.dbc_machine = response.data.brand + " " + response.data.alias;

      formData.hulpstukken = []

      if (response.data.hulpstukken) {
        for (let x = 0 ; x < response.data.hulpstukken.length; x++) {
          if (response.data.hulpstukken[x].naam !== "") {
            formData.hulpstukken.push([response.data.hulpstukken[x].naam, response.data.hulpstukken[x].nummer, response.data.hulpstukken[x].kleur])
          }
        }
      }

      setFormData({
        ...formData
      });
    }

    const getImage = async () => {
      try {
        const response = await axios.get(`/api/img/${serialNumber}`, {
          withCredentials: true,
        });

        setImage(response.data.url);
      } catch (error) {
        console.log(error);
      }
    }

    const getManual = async () => {
      try {
        const response = await axios.get(`/api/manual/${serialNumber}`);
        setManual(response.data.url);
      } catch (error) {
        console.log(error);
      }
    }

    const getConfig = async () => {
      const response = await axios.get(`/api/machine/config/download`, {
        params: {
          serienummer: serialNumber,
        }
      })

      const blob = new Blob([response.data], { type: 'application/xml' })
      const blobUrl = URL.createObjectURL(blob)

      setConfigUrl(blobUrl);
    }

    const getMachines = async () => {
      const response = await axios.get(`/api/machine/get/all`);

      await setFormData({
        ...formData,
        machines: response.data,
      });
    };

    const fetchOrganizations = async () => {
      try {
        const response = await axios.get(`/api/organization/get/electric`);

        await setOrganizations(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    loadMachine()
    getImage()
    getManual()
    getConfig()
    fetchOrganizations()
    getMachines()
  }, []);

  // const getHulpstukken = async () => {
  //   const response = await axios.get(`/api/machine`, {
  //     params: {
  //       merk: formData.hulpstuk_machine,
  //     }
  //   })
  //   console.log(response)
  //   formData.hulpstukken = []
  //   for (const hulpstuk in response.data.hulpstukken) {
  //     if (response.data.hulpstukken[hulpstuk].naam !== "") {
  //       formData.hulpstukken.push([response.data.hulpstukken[hulpstuk].naam, response.data.hulpstukken[hulpstuk].nummer])
  //     }
  //     setFormData({
  //       ...formData
  //     });
  //   }
  // }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    console.log(formData);
  };

  const handleChangeList = () => {
    if (formData.hulpstuk !== '') {
      setFormData({
        ...formData,
        hulpstukken: [...formData.hulpstukken, [formData.hulpstuk, parseInt(formData.hulpstuknummer), formData.hulpstukkleur]],
        hulpstuk: '',
        hulpstuknummer: 0,
      });
    }
  };

  const Edit = async () => {
    await axios.get('/api/machine/edit', {
      params: {
        brand: formData.machine_Merk,
        hulpstukken: formData.hulpstukken,
        alias: formData.machine_Naam,
        model: formData.machine_Model,
        bedrijf: formData.organisatie,
        cleanorg: formData.cleanorg,
        macaddress: formData.macaddress,
        machine_serial: formData.machine_Serienummer,
        influx_serial: formData.influx_Serienummer,
        dbc_machine: formData.dbc_machine,
        elektrischOnderstel: formData.elektrischOnderstel,
      }
    });
    window.location.href=formData.machine_Serienummer;
  };

  const deleteHulpstuk = (index) => {
    setFormData({
      ...formData,
      hulpstukken: formData.hulpstukken.filter((_, i) => i !== index)
    });
  };

  const DeleteImage = async (e) => {
    await axios.post("/api/img/delete", {
      serial:formData.machine_Serienummer
    })
    window.location.reload();
  }

  const DeleteManuals = async (e) => {
    await axios.post("/api/manual/delete", {
      serial:formData.machine_Serienummer
    })
    window.location.reload();
  }

  const UploadImage = async (e) => {
    e.preventDefault();

    let files = e.target.files;

    const fileReader = new FileReader();
    fileReader.readAsDataURL(files[0]);

    fileReader.onload = async () => {
      const response = await axios.post("/api/img/upload", {
        name: files[0].name, serial:formData.machine_Serienummer, file: fileReader.result
      })

      console.log(response)
      window.location.reload();
    };
  }

  const UploadManual = async (e) => {
    e.preventDefault();

    let files = document.querySelector("#manual-upload").files;

    console.log(files);

    const fileReader = new FileReader();
    fileReader.readAsDataURL(files[0]);

    fileReader.onload = async () => {
      await axios.post("/api/manual/upload", {
        name: files[0].name, serial:formData.machine_Serienummer, file: fileReader.result, size: files[0].size
      })
    };
  }

  const formList = ["influx_Serienummer", "machine_Serienummer", "machine_Merk", "machine_Naam", "machine_Model"]

  return (
    <div className={"pl-14 pr-14 flex flex-col gap-10 p-2"}>
      <div className="flex gap-10">
        <dialog id={"loading"} open className={"top-52 z-50 text-center text-9xl p-10 rounded-lg shadow-xl bg-white select-none hidden flex-col gap-10"}>
          Laden...
          <h1 className={"text-2xl"}>dit kan even duren</h1>
        </dialog>
        <div className="flex w-2/6 flex-col items-center justify-between bg-white rounded-md shadow-lg p-8">
          <h1 className={"text-gray-700 font-bold pl-3 text-3xl"}>Update Een Machine</h1>
          <form onSubmit={Edit} id={"form"} className="flex flex-col items-center gap-4 rounded-md justify-center w-full">
            <div className="w-full flex flex-col gap-1">
              <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Organisatie</h1>
              <select className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" onChange={handleChange} name={"organization"} value={formData.organisatie}>
                {organizations.map((organization) => (
                  <option className={"text-gray-500 text-xl"} key={organization._id} value={organization.name}>
                    {organization.clean}
                  </option>
                ))}
              </select>
            </div>
            {formList.map((name) => (
              <div key={name} className="w-full flex flex-col gap-1">
                <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>{name.toLocaleUpperCase()[0] + name.slice(1).replace("_", " ")}</h1>
                <input
                  className="w-full text-xl p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal"
                  type="text"
                  placeholder={"Vul " + name.toLocaleUpperCase()[0] + name.slice(1).replace("_", " ") + " In"}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required
                />
              </div>
            ))}
            <div className="w-full flex flex-col gap-1">
              <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Mac-Adress</h1>
              <input className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" type="text" placeholder="000 00 AS0 A0000" name="macaddress" value={formData.macaddress} onChange={handleChange}/>
            </div>
            <input
              className="w-fit text-2xl text-center rounded-md py-2 px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"
              type="submit" value={"Machine Opslaan"}
            />
          </form>
        </div>

        <div className="flex flex-col w-1/4 justify-between">

          {/*<div className="flex flex-col items-center gap-5 bg-white rounded-md shadow-lg justify-center p-8">*/}
          {/*  <div className="w-full flex flex-col gap-1">*/}
          {/*    <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Kies een machine voor hulpstukken</h1>*/}
          {/*    <select className="w-full text-xl text-gray-500 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" onChange={handleChange} name={"hulpstuk_machine"} value={formData.hulpstuk_machine}>*/}
          {/*      <option disabled={true} hidden={true} selected={true}>Selecteer Machine Voor Hulpstukken</option>*/}

          {/*      {formData.machines.map((machine) => (*/}
          {/*        <option className={"text-gray-500 text-xl"} key={machine._id || machine.brand} value={machine.brand + " " + machine.alias}>*/}
          {/*          {machine.brand + " " + machine.model}*/}
          {/*        </option>*/}
          {/*      ))}*/}
          {/*    </select>*/}
          {/*  </div>*/}
          {/*  <input*/}
          {/*    className="w-fit text-2xl text-center rounded-md py-2 px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"*/}
          {/*    type="button" value="Importeer" onClick={getHulpstukken}*/}
          {/*  />*/}
          {/*</div>*/}

          <div className="flex flex-col gap-5 bg-white rounded-md shadow-lg p-6">
            <form className={"w-full"}>
              <label htmlFor={"image-upload"} className={"w-full inline-block text-2xl text-center rounded-md py-2 self-center px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"}>Upload Foto</label>
              <input id={"image-upload"} className={"hidden"} type={"file"} onChange={UploadImage}/>
            </form>
            <form className={"w-full"}>
              <label htmlFor={"manual-upload"} className={"w-full inline-block text-2xl text-center rounded-md py-2 self-center px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"}>Upload Handleiding</label>
              <input id={"manual-upload"} className={"hidden"} type={"file"} onChange={UploadManual}/>
            </form>
          </div>

          <div className="flex flex-col gap-5 bg-white rounded-md shadow-lg p-6">
            <a className={"w-full inline-block text-2xl text-center rounded-md py-2 self-center px-6 bg-blue-500 text-white shadow-xl hover:cursor-pointer"} download={"config.xml"} href={configUrl ? configUrl : ""}>Download Config Bestand</a>
          </div>

          <div className="flex flex-col gap-5 bg-white rounded-md shadow-lg p-6">
            <a className={"w-full inline-block text-2xl text-center rounded-md py-2 self-center px-6 bg-blue-500 text-white shadow-xl hover:cursor-pointer"} href={manual ? manual : ""} target={configUrl ? "_blank" : "_self"}>Handleiding is{manual ? "" : " niet"} Beschikbaar</a>
            <button className={"w-full inline-block text-2xl text-center rounded-md py-2 self-center px-6 bg-red-500 text-white shadow-xl hover:cursor-pointer"} onClick={DeleteManuals}>Delete</button>
          </div>

          <div className="flex flex-col gap-5 bg-white items-center rounded-md shadow-lg p-6">
            <div className="flex justify-between w-full">
              <h1 className={"font-bold text-xl text-gray-600"}>Image: </h1>
              <button className={"w-8 h-8"} onClick={DeleteImage}><img src={"/delete.svg"} alt={"delete"}/></button>
            </div>
            <img style={image ? {} : {paddingTop: "40px"}} className={"rounded-full h-60 w-60 object-cover overflow-hidden text-center"} src={image ? image : null} alt={image ? "" : "No Image Was Found"}/>
          </div>
        </div>

        <div className="flex flex-col gap-5 w-5/12 h-full">
          <div
            className="flex w-full h-[610px] grow flex-col items-center gap-5 bg-white rounded-md shadow-lg justify-center p-8">
            <h1 className={"text-gray-700 font-bold pl-3 text-3xl"}>Hulpstuk Lijst</h1>
            <ul className="flex flex-col gap-4 w-full h-full overflow-y-scrollbar relative overflow-auto grow">
              {formData.hulpstukken.length > 0 ? formData.hulpstukken.map((hulpstukken, index) => (
                <li key={index} className="w-full flex text-xl gap-2 text-gray-300 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal">
                  <span style={{background: hulpstukken[2]}} className={"w-10 h-10 rounded-sm"}></span>
                  <h1 className="text-gray-700 w-3/5 select-none">{hulpstukken[0]}</h1>
                  <h1 className="text-gray-700 w-2/5 select-none">{hulpstukken[1]}</h1>
                  <img onClick={() => deleteHulpstuk(index)} className="absolute right-3 h-8 w-7 hover:cursor-pointer" src="/delete.svg" alt="delete"/>
                </li>
              )): ""}
            </ul>
          </div>

          <div className="flex w-full flex-col gap-5 bg-white rounded-md shadow-lg p-8">
            <div className="w-full flex gap-2">
              <div className="w-4/6 flex flex-col gap-1">
                <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Hulpstuk Naam</h1>
                <input className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" type="text" placeholder="Nieuw Hulpstuk" name="hulpstuk" value={formData.hulpstuk} onChange={handleChange} required/>
              </div>
              <div className="w-1/6 flex flex-col gap-1">
                <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Nummer</h1>
                <input placeholder={"0"} className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600 border leading-normal" type="number" name="hulpstuknummer" value={formData.hulpstuknummer} onChange={handleChange} required/>
              </div>
              <div className="w-1/6 flex flex-col gap-1">
                <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Kleur</h1>
                <input placeholder={"#000000"} className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600 border leading-normal" type="text" name="hulpstukkleur" value={formData.hulpstukkleur} onChange={handleChange} required/>
              </div>
            </div>

            <input className="w-fit text-2xl text-center rounded-md py-2 self-center px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer" onClick={handleChangeList} value="Voeg Hulpstuk Toe" type="button"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMachine;